import { render } from "./Grouping.vue?vue&type=template&id=0d317e65"
import script from "./Grouping.vue?vue&type=script&lang=js"
export * from "./Grouping.vue?vue&type=script&lang=js"
script.render = render

export default script